export default __webpack_public_path__ + "static/media/BlueVector.b747a056.png";